import styled from 'styled-components';
import Link from '../../../Link';

export const RelatedRoot = styled.div`
	width: 100%;
	box-sizing: border-box;
`;

export const RelatedList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
`;
export const LabelWrapper = styled.div`
	grid-area: apart;
	display: flex;
	flex-direction: column;
	row-gap: 8px;
	${({ theme }) => theme.typography.textSemiBoldS};
	color: ${({ theme }) => theme.primaryBlackColor};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textS};
		row-gap: 2px;
	}
`;
export const RoundProp = styled.div`
	grid-area: floor;
	padding: 8px 16px;
	min-width: 50px;
	display: flex;
	justify-content: center;
	justify-self: center;
	color: ${({ theme }) => theme.primaryBlackColor};
	background: ${({ theme }) => theme.grayColor};
	${({ theme }) => theme.typography.textS};
	border-radius: 20px;
	height: fit-content;

	@media (max-width: 600px) {
		justify-self: end;
	}
`;

export const PriceTotal = styled.div`
	grid-area: price;
	${({ theme }) => theme.typography.textBoldL};
	color: ${({ theme }) => theme.primaryBlackColor};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textBoldM};
	}
`;

export const PriceMeter = styled.div`
	grid-area: priceMeter;
	${({ theme }) => theme.typography.textS};
	color: ${({ theme }) => theme.darkGrayColor};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textXS};
	}
`;

export const RelatedCard = styled(Link)`
	text-decoration: none;
	cursor: pointer;

	display: grid;
	grid-column-gap: 4px;
	grid-row-gap: 30px;
	grid-template-areas: 'apart floor price priceMeter button';
	grid-template-columns: 1.1fr 0.9fr 1fr 1fr 1fr;
	align-items: center;
	overflow: hidden;

	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.lightGrayColor};
		padding-bottom: 18px;
	}

	@media (max-width: 600px) {
		grid-row-gap: 10px;
		grid-template-rows: 1fr 1fr;
		grid-template-columns: 0.8fr 1.2fr 1fr;

		grid-template-areas:
			'apart apart floor'
			'price priceMeter .';
	}

	&:hover {
		${LabelWrapper},
		${PriceTotal} {
			color: ${({ theme }) => theme.primaryColor};
		}
	}
`;
